import { render, staticRenderFns } from "./result.vue?vue&type=template&id=5fe683fa&scoped=true"
import script from "./result.vue?vue&type=script&lang=ts"
export * from "./result.vue?vue&type=script&lang=ts"
import style0 from "./result.vue?vue&type=style&index=0&id=5fe683fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe683fa",
  null
  
)

export default component.exports